export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-format/src/identity.js
// module id = 643
// module chunks = 0